// extracted by mini-css-extract-plugin
export default {"icon":"Skills_icon__OQQbq"};